import React from "react";
import { Box, Button, Stack } from "@mui/material";
import moment from "moment";

import SortableTable, { TSortableColumn } from "../../common/SortableTable";

import { formatCurrency } from "../../../../helpers";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectProductHistories } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { IProductHistory } from "../../../../features/productAnalyzer/productAnalyzer.types";
import { useProductAnalyzer } from "../../../../contexts/productAnalyzerContext";
import { getProductHistoriesThunk } from "../../../../features/productAnalyzer/productAnalyzer.thunk";

const TABLE_COLUMNS: TSortableColumn<IProductHistory>[] = [
  {
    header: "Action",
    accessorKey: "type",
    align: "center",
  },
  {
    header: "Cost",
    accessorKey: "costPrice",
    formatter: ({ costPrice }) => formatCurrency(costPrice),
  },
  {
    header: "Price",
    accessorKey: "salePrice",
    formatter: ({ salePrice }) => formatCurrency(salePrice),
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
    formatter: ({ quantity }) =>
      quantity !== null ? quantity?.toLocaleString() : "",
  },
  {
    header: "Date",
    accessorKey: "createdAt",
    formatter: ({ createdAt }) =>
      moment(createdAt).format("MM/DD/YYYY, h:mm A"),
  },
];

const HistoryCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const { asin } = useProductAnalyzer();
  const { total, histories, isLoading } = useAppSelector(
    selectProductHistories,
  );

  const handleLoadMore = () => {
    dispatch(
      getProductHistoriesThunk({
        asin,
        page: Math.floor(histories.length / 5) + 1,
        perPage: 5,
      }),
    );
  };

  return (
    <Stack direction="column">
      <SortableTable
        columns={TABLE_COLUMNS}
        data={histories}
        defaultSort={{
          accessorKey: "createdAt",
          order: "desc",
        }}
      />

      {histories.length < total && (
        <Box sx={{ padding: "4px 4px" }}>
          <Button
            size="medium"
            variant="contained"
            loading={isLoading}
            onClick={handleLoadMore}
          >
            Load More
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default HistoryCard;
